import React from 'react'

import {
  Body1,
  Col,
  Grid,
  GridVariant,
  Heading2,
  Link,
  TextAlign,
  Space,
  Heading1,
} from '@gousto-internal/citrus-react'
import Helmet from 'react-helmet'

import { getStaticAssetURL } from '@library/static-assets'

import policy from 'config/policy'

import { CookiesPolicy } from './CookiePolicy/CookiesPolicy'

const PrivacyStatement = () => (
  <Grid variant={GridVariant.Layout}>
    <Col size={12}>
      <Helmet title={policy.head.title} meta={policy.head.meta} />
      <Space size={4} />
      <Heading1 textAlign={TextAlign.Center}>Privacy & Cookies Policy</Heading1>
      <section id="privacy-policy">
        <Space size={4} />
        <Heading2 textAlign={TextAlign.Center}>Privacy Policy</Heading2>
        <Space size={4} />
        <Body1>
          Want to read all about how we handle your data? Check out the{' '}
          <Link href={`${getStaticAssetURL('/pdfs/Gousto_Privacy_Policy_V3.pdf')}`} target="_blank">
            Gousto Privacy Policy
          </Link>{' '}
          for everything you need to know.
        </Body1>
      </section>
      <CookiesPolicy />
    </Col>
  </Grid>
)

export { PrivacyStatement }
